module.exports = __webpack_public_path__ + "img/In Pursuit of a Low Fossil Energy Future.73fe4457.jpg";